import React from "react";
import styled from "styled-components";
import { AlertNavigationType, getNavigationStyles } from "../../utils/alertUtils";
import { CIcon, CText } from "@carrefour/design-system-components-react";

interface AlertSectionHeaderProps {
  status: AlertNavigationType;
  label: string;
  count?: number;
}

const Wrapper = styled.div`
  display: flex;
  flex-basis: 100%;
  gap: 0.3rem;
`;

const CIconCustom = styled(CIcon)<{ color?: string }>`
  color: ${(props) => props.color} !important;
`;

const Divider = styled.div`
  flex: 1;
  margin-top: 10px;
  height: 1px;
  background-color: #ebebeb;
  margin-left: 5px;
`;

const AlertSectionHeader: React.FC<AlertSectionHeaderProps> = ({
  status,
  label,
  count,
}) => {
  const navigationStyles = getNavigationStyles(status);

  return (
    <Wrapper>
      <CIconCustom name={navigationStyles?.icon} color={navigationStyles?.color} />
      <CText bold>{label}</CText>
      {count && count > 0 ? <CText bold>{count}</CText> : null}
      <Divider />
    </Wrapper>
  );
};

export default AlertSectionHeader;